import FirebaseContext from "../firebase/firebaseContext";
import React, { useContext, useState, useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

const Login = props => {
  const firebaseContext = useContext(FirebaseContext);
  const { auth } = firebaseContext;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userInfo, setUserInfo] = useState("");
  const [user, setUser] = useState({ authenticated: false });

  const onLogin = e => {
    e.preventDefault();
    firebaseContext.login(email, password);
    props.history.push("/");
  };

  const authListen = setUser => {
    return auth.onAuthStateChanged(user => {
      if (user) {
        setUser({ authenticated: true });
        setUserInfo({ email: user.email });
      } else {
        setUser({ authenticated: false });
      }
    });
  };

  useEffect(() => {
    const unsubscribe = async () => {
      await authListen(setUser);
      console.log(user);
    };
    unsubscribe();
  }, []);

  return (
    <div>
      <div className='login-container'>
        <form onSubmit={e => onLogin(e)}>
          <input
            type='text'
            className='form-input'
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder='email'
          />
          <input
            type='text'
            className='form-input'
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder='password'
          />
          <button type='submit' className='form-button'>
            Submit
          </button>

          <div>
            <p style={{ fontSize: "2rem" }}>
              Dragi učenci. Ta zavihek je namenjen učiteljem. Ne preizkušajte
              različnih gesel, ipd. Če čutite potrebo po preizkušanju vpisa, vam
              prijazni učitelj daje namig:
            </p>
            <p>Email se začne na: "k".</p>
            <p>
              Če predpostavljate, da ima tipkovnica, upoštevajoč velike črke in
              simbole, 92 možnosti, je možnosti za geslo 92 na 31. Dobimo
              število 75.4 "novemdecilion". <br></br>Če boste poizkusili bilijon
              gesel na sekundo, boste potrebovali le 2.4 tridecilijona let, da
              jih vse stestirate.
            </p>
            <p>Učitelji vam svetujemo, da se raje posvetite nalogam :).</p>

            <p>
              Za izračune si ne jemljemo zaslug saj so pridobljeni s spleta.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
